// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"209":"dce419be","312":"b1d0992f","358":"c7e36581","375":"32eb7b16","484":"14cb0921","629":"3c99ad5f","672":"477a6254","800":"d79d84e4","828":"6cc522b3","842":"01821987","851":"3f0086ba","869":"b6dda42b","974":"87dcfbc9"}[chunkId] + ".chunk.js";
};